import React from 'react';
import { IconLibraryItem } from './IconLibraryItem';

export const ButtonIcon = ({ icon, iconSize, ...otherProps }) => {
  return <IconLibraryItem name={icon} iconSize={iconSize} {...otherProps} />;
};